// extracted by mini-css-extract-plugin
module.exports = {"Modal":"ErrorModal_Modal__2vVaR","Red":"ErrorModal_Red__hop0O","Exclamation":"ErrorModal_Exclamation__2jg29"};